import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';

import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { CustomBreadCrumbsStyles } from '../../styles/CustomStyles';
import { AppHelper } from '../../helpers/AppHelper';
import { truncateSync } from 'fs';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});
export class PageDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title || '',
      customHeaderContent: null,
    }
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  setCustomHeader = (content) => {
    this.setState({ customHeaderContent: content });
  }

  onCloseModal() {
    this.setState({});
    if (this.props.onClosed) { this.props.onClosed(); }
  }

  fullWidthCondition(fullWidthDialog) {
    if (fullWidthDialog) {
      return true
    }
    return false
  }


  render() {
    const pageComponentProps = {
      ...this.props.PageComponentProps,
      pageDialogMode: true,
      setDialogHeader: this.setCustomHeader
    }
    const fullWidthDialog = (this.props.fullWidthDialog && window.innerWidth > 480)
    const dialogHeading = this.props.title || ''
    const preventClose = !!this.props.preventClose
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.state.title}
        fullWidth={this.props.fullWidth}
        TransitionComponent={window.innerWidth < 768 ? Transition : Fade}
        fullScreen={this.fullWidthCondition(fullWidthDialog)}
        classes={{
          root: css(Styles.customRoot),
          paper: css(
            Styles.customPaper,
            this.props.fullHeight && Styles.customPaperFullHeight,
            AppHelper.isDialogScrollbarEnabled() && AppStyles.dialogScrollbar
          ),
        }}
        BackdropProps={fullWidthDialog && { style: { backgroundColor: 'unset' } }}
        maxWidth={this.props.maxWidth || 'lg'}
        disableBackdropClick={preventClose}
        disableEscapeKeyDown={preventClose}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitleContainer)}>
            <div className={css(Styles.modalTitle, this.props.backTitle && Styles.modalTitleWithBack)}>{dialogHeading}</div>
            {!preventClose && (this.props.backTitle ? (
              <button className={css(Styles.modalCloseButton, Styles.modalBackButton)} onClick={this.onCloseModal} disabled={this.state.inProcess}>
                <Typography className={css(CustomBreadCrumbsStyles.textStyleButton)}>
                  <i className='material-icons-outlined' style={{ fontSize: 14, color: AppTheme.buttonTextColor, marginRight: 2 }}>arrow_back_ios</i>
                  {this.props.backTitle}
                </Typography>
              </button>
            ) : (
              <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal} disabled={this.state.inProcess}>
                <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
                  <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
                </svg>
              </button>
            ))}
          </div>
          {this.state.customHeaderContent && <div className={css(Styles.customHeaderContainer)}>
            {this.state.customHeaderContent}
          </div>}
        </div>
        <div className={css(this.props.fullHeight ? [Styles.modalContent, Styles.modalContentFullHeight] : Styles.modalContent)} id='modalContainer'>
          {this.props.isOpen ? <this.props.PageComponent {...pageComponentProps} /> : ''}
        </div>
      </Dialog>
    );
  }
}

const Styles = StyleSheet.create({
  modalHeader: {
    // backgroundColor: 'whitesmoke',
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 10,
    '@media (max-width: 1024px)': {
      position: 'sticky',
      top: 0,
      backgroundColor: AppTheme.secondaryBg,
      zIndex: 1000,
      paddingLeft: 15,
      paddingRight: 15,
    }
  },
  modalTitleContainer:{
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 20,
  },
  modalTitle: {
    color: 'black',
    fontSize: 26,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginRight: 28,
    '@media (max-width: 767px)': {
      marginRight: 43,
    }
  },
  modalTitleWithBack: {
    marginRight: 0,
    '@media (max-width: 767px)': {
      marginRight: 0,
    }
  },
  modalContent: {
    position: 'relative',
    overflowY: 'auto',
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 15,
    '@media (max-width: 1024px)': {
      paddingLeft: 15,
      paddingRight: 15,
      overflowY: 'unset'
    }
  },
  modalContentFullHeight: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  modalCloseButton: {
    // position: 'absolute',
    // top: 23,
    // right: 30,
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
    border: 'none'
  },
  modalBackButton: {
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    border: '1.5px solid' + AppTheme.primaryColor,
    fill: AppTheme.primaryColor,
    borderRadius: 8
  },
  customRoot: {
    zIndex: 13000
  },
  customPaper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      // borderRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      width: '100%',
      bottom: 0,
      position: 'fixed',
      margin: 0,
      marginTop: 0,
      maxHeight: 'calc(100% - 50px)'
    },
    '::-webkit-scrollbar': {
      display: 'none'
    },
  },
  customPaperFullHeight: {
    height: '98vh',
    maxHeight: '98vh',
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 1024px)': {
      height: 'calc(100% - 50px)',
      maxHeight: 'calc(100% - 50px)',
    },
  },
  tooltip: {
    zIndex: 9999999999,
    maxWidth: 250
  },
  customHeaderContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
})
